document.addEventListener('DOMContentLoaded', function() {
	var openBtns = document.querySelectorAll('.open-product-enquiry-form');
	var modal = document.getElementById('productEnquiryFormModal');
	var formWrapper = document.getElementById('productEnquiryForm');
	var closeBtn = document.getElementById('closeProductEnquiryForm');
	var closeText = document.getElementById('closeProductEnquiryFormText');
	var productDesc = document.querySelector('.product-desc');

	if (!modal) return;

	// ---------- Modal functions ----------
	function openModal() {
	  modal.classList.add('is-visible');
	  document.body.classList.add('no-scroll');
	}

	function closeModal() {
	  modal.classList.remove('is-visible');
	  document.body.classList.remove('no-scroll');
	}

	// ---------- Event bindings ----------
	if (openBtns.length) {
		openBtns.forEach(function(btn) {
			btn.addEventListener('click', function(e) {
			e.preventDefault(); // optional (useful if it's a link)
			openModal();
			});
		});
	}
	if (closeBtn) closeBtn.addEventListener('click', closeModal);
	if (closeText) closeText.addEventListener('click', closeModal);

	modal.addEventListener('click', function(e) {
	  if (e.target === modal) closeModal();
	});

	document.addEventListener('keydown', function(e) {
	  if (e.key === 'Escape' || e.key === 'Esc') closeModal();
	});

	// ---------- Reopen modal automatically if form was submitted successfully ----------
	if (formWrapper && formWrapper.dataset.success === 'true') {
	  openModal();
	}

	// ---------- Check for ?contact_posted=true in URL ----------
	if (window.location.search.includes('contact_posted=true')) {
	  openModal();

	  // Optional: clear the query from the address bar (for cleaner reloads)
	  const newUrl = window.location.pathname;
	  window.history.replaceState({}, '', newUrl);
	}

	// ---------- Hide Enquiry Button when .product-desc.shown ----------
	if (productDesc && openBtn) {
	  // Observe class changes
	  var observer = new MutationObserver(function(mutations) {
	    mutations.forEach(function(mutation) {
	      if (mutation.attributeName === 'class') {
	        var isShown = productDesc.classList.contains('shown');
	        openBtn.style.display = isShown ? 'none' : '';
	      }
	    });
	  });

	  observer.observe(productDesc, { attributes: true });

	  // Set initial state
	  if (productDesc.classList.contains('shown')) {
	    openBtn.style.display = 'none';
	  }
	}
});
